<p *ngIf="fieldDescription" class="mb-0 mt-2">
  {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
</p>
<mat-form-field *ngIf="!readonly" class="w-100" [ngClass]="{ 'no-label': hideLabel }"
  appearance="outline"
  floatLabel="always">
  <mat-label>
    {{ labelOverride || fgInfo?.label
    }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-label>
  <input
    type="number"
    [attr.data-automation-id]="dataAutomationId"
    [required]="fgInfo.required"
    matInput
    [placeholder]="placeholder"
    [formControl]="formControl"
    [max]="fgInfo.maxValue"
    [min]="fgInfo.minValue"
    (keydown)="onInputKeyDown($event)"
  />
  <mat-hint>{{ hint }}</mat-hint>
     <mat-error *ngIf="errorDefinitions?.length">
    <ng-container *ngFor="let errorDefinition of errorDefinitions">
      <span *ngIf="formControl?.touched && errorDefinition.showFunction() && errorDefinition.errorMessage(formControl)"> {{ errorDefinition.errorMessage(formControl) }}</span>
    </ng-container>
  </mat-error>

</mat-form-field>
<ng-container *ngIf="readonly">
  <mat-form-field
    class="no-underline w-100"
    [floatLabel]="'always'"
    [ngClass]="{ 'read-only': readonly, 'no-label': hideLabel }"
  >
    <mat-label>{{ labelOverride || fgInfo?.label }}</mat-label>
    <input
      readonly
      matInput
      [attr.data-automation-id]="dataAutomationId"
      [value]="formControl.value"
      tabindex="-1"
    />
  </mat-form-field>
</ng-container>
